module.exports = __webpack_public_path__ + "assets/img/paddling-paws.a306b7fb.png";